var render = function render(){var _vm=this,_c=_vm._self._c;return _c('persons',{attrs:{"type":"external"}})
}
var staticRenderFns = []

export { render, staticRenderFns }